import EventBus from './EventBus';

class BusEvent {
	public readonly name: string;

	constructor(name: string) {
		this.name = name;
	}
	/**
	 * Генерация события
	 */
	emit(...args: any[]): void {
		EventBus.emit(this.name, ...args);
	}
	/**
	 * Подписка на событие
	 */
	on(callback: Function): void {
		EventBus.on(this.name, callback);
	}
	/**
	 * Отписка от события
	 */
	off(callback?: Function): void {
		EventBus.off(this.name, callback);
	}
	/**
	 * Одноразовая подписка на событие
	 */
	once(callback: Function): void {
		EventBus.once(this.name, callback);
	}
	/**
	 * Подписка на событие, alias
	 */
	addEventListener(callback: Function): void {
		this.on(callback);
	}
	/**
	 * Отписка от события, alias
	 */
	removeEventListener(callback?: Function): void {
		this.off(callback);
	}
}

export default BusEvent;
